module.exports = __webpack_public_path__ + "static/media/NPXS.fa1929ed.svg";